import React from 'react';
import Layout from '../../../layout/Layout';
import HeaderPageSection from 'core/presentation/components/molecules/HeaderPageSection/HeaderPageSection';
import CreateRuleForm from '../organisms/CreateRuleForm';


export default function CreateRule() {
    return (
        <Layout>
            <HeaderPageSection
                title="Crear nueva regla"
                showGoBack={false}
                breadcrumbItems={[
                    { label: 'Reglas', path: '/rules' },
                    { label: 'Crear Regla', path: '#' },
                ]}
            />
            <div className="w-full">
                <CreateRuleForm />
            </div>
        </Layout>

    )
}

